const activitypackagecomment = {
    add: 'activitypackagecomment/add-by-admin',
    getlist: 'activitypackagecomment/getlist-by-admin',
    update: 'activitypackagecomment/update',
    remove: 'activitypackagecomment/remove',
    get: 'activitypackagecomment/get',
}
export default activitypackagecomment
